import { Injectable } from '@angular/core'
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { SalonmonsterHttpClient } from './salonmonster-http-client'
import { ErrorHandlerService } from './error-handler.service'
import { UserService } from './user.service'

import { StripeSubscriptionService } from './stripe-subscription.service'
import { Observable, throwError, of, forkJoin } from 'rxjs'
import { ENV_CONFIG } from '../../bin/env.config'
import { catchError, map, switchMap } from 'rxjs/operators'

@Injectable()
export class SubscriptionService {
  constructor (
    private userService: UserService,
    private stripeSubscriptionService: StripeSubscriptionService,
    protected errorHandlerService: ErrorHandlerService
  ) {}

  public getSubscriptionPlatform (): Observable<string | null> {
    return this.stripeSubscriptionService.fetchStripeCustomerID().pipe(
      map(data => {
        console.log('fetchStripeCustomerID data:', data)
        return data ? 'stripe' : null
      }),
      switchMap(data => {
        if (data === 'stripe') {
          // stripe is our new subscription platform, return stripe if there is a stripe customer id
          console.log('stripe: true')
          return of('stripe')
        } else if (
          this.userService.getSalon().chargifyID !== undefined &&
          this.userService.getSalon().chargifyID !== 0
        ) {
          console.log('chargify: true')
          // chargify is our old subscription platform, return chargify if there is a chargify id AND no stripe customer id
          return of('chargify')
        } else {
          // no subscription platform found, return none
          return of('none')
        }
        return of('none')
      })
    )
  }
}
